import React, { useState } from 'react';
import { formatCurrency, CONFIG, totalCarried } from '../gameData';
import AlertDialog from './AlertDialog';

function DrugMarket({ player, setPlayer, prices, gameEnded }) {
  const [quantities, setQuantities] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const carried = totalCarried(player.inventory);
  const capacityLeft = CONFIG.inventoryCapacity - carried;

  const handleQuantityChange = (drug, value) => {
    setQuantities(prev => ({ ...prev, [drug]: parseInt(value) || 1 }));
  };

  const showAlertMessage = (message) => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const buy = (drug) => {
    const quantity = quantities[drug] || 1;
    const unitPrice = prices[drug];
    const totalCost = unitPrice * quantity;

    if (totalCost > player.money) {
      showAlertMessage("Not enough money to buy!");
      return;
    }
    if (quantity > capacityLeft) {
      showAlertMessage(`You can only carry ${CONFIG.inventoryCapacity} units. You have room for ${capacityLeft} more.`);
      return;
    }

    setPlayer(prev => ({
      ...prev,
      money: prev.money - totalCost,
      inventory: {
        ...prev.inventory,
        [drug]: (prev.inventory[drug] || 0) + quantity
      }
    }));
    // Reset slider after purchase
    setQuantities(prev => ({ ...prev, [drug]: 1 }));
  };

  const sell = (drug) => {
    const quantity = quantities[drug] || 1;
    if (player.inventory[drug] && player.inventory[drug] >= quantity) {
      setPlayer(prev => ({
        ...prev,
        money: prev.money + (prices[drug] * quantity),
        inventory: {
          ...prev.inventory,
          [drug]: prev.inventory[drug] - quantity
        }
      }));
      // Reset slider after sale
      setQuantities(prev => ({ ...prev, [drug]: 1 }));
    } else {
      showAlertMessage("Not enough inventory to sell!");
    }
  };

  return (
    <div>
      <h2>Drugs Market</h2>
      <p className="section-hint">
        Stash: <strong>{carried} / {CONFIG.inventoryCapacity}</strong> units carried
      </p>
      <table>
        <thead>
          <tr>
            <th>Drug</th>
            <th>Price</th>
            <th>Inventory</th>
            <th>Quantity</th>
            <th>Buy/Sell</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(prices).map(([drug, price]) => {
            const inventoryCount = player.inventory[drug] || 0;
            const maxBuyable = Math.min(Math.floor(player.money / price), capacityLeft);
            const maxSellable = inventoryCount;
            
            return (
              <tr key={drug}>
                <td>{drug}</td>
                <td>{formatCurrency(price)}</td>
                <td>{inventoryCount}</td>
                <td>
                  <input
                    type="range"
                    min="1"
                    max={Math.max(1, maxBuyable, maxSellable)}
                    value={quantities[drug] || 1}
                    onChange={(e) => handleQuantityChange(drug, e.target.value)}
                    disabled={gameEnded}
                  />
                  <span>{quantities[drug] || 1}</span>
                </td>
                <td>
                  <button onClick={() => buy(drug)} disabled={gameEnded}>Buy</button>
                  <button onClick={() => sell(drug)} disabled={gameEnded}>Sell</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      
      <AlertDialog
        show={showAlert}
        message={alertMessage}
        onClose={() => setShowAlert(false)}
      />
    </div>
  );
}

export default DrugMarket; 